import template from './accept-modal.html';
import controller from './accept-modal.controller';

export default {
  template,
  controller,
  bindings: {
    task: '<',
    closeModal: '&',
    onActionSubmit: '&',
  }
}



// WEBPACK FOOTER //
// ./src/app/screens/engineer/screens/tasks/screens/task-detail/components/accept-modal/index.js